import { alpha, darken, fontWeight, lighten } from "@mui/system";

// Base compartilhada pelos chips de status; só a cor muda entre eles.
const chipBase = {
  border: "0.6px solid",
  borderRadius: "10px",
  height: "20px",
  width: "100%",
  fontSize: "0.7rem",
  "& .MuiChip-label": { px: "6px" },
};

const chipStatus = (background, text) => ({
  ...chipBase,
  backgroundColor: background,
  color: text,
  borderColor: text,
});

const styles = (theme) => ({
  container: { display: "flex", flexDirection: "column", gap: 0 },
  content: { display: "flex", flexDirection: "column", gap: 1 },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexGrow: 1,
    gap: 2,
    "@media (max-width: 400px)": {
      flexDirection: "column",
    },
  },
  filterBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  formControl: {
    display: "flex",
    width: "130px",
    minWidth: "130px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "primary",
      color: "primary",
    },
    "& .MuiInputLabel-root": {
      color: "primary",
    },
    svg: {
      color: "primary",
    },
    input: {
      color: "primary",
    },
  },
  paperClientes: {
    width: "100%",
    height: "500px",
    overflow: "hidden",
    borderRadius: "10px",
    position: "relative",
    p: "10px",
  },
  animatedTabFrame: {
    position: "relative",
    width: "100%",
    height: "500px",
    minHeight: 0,
    overflow: "hidden",
  },
  animatedTabPanel: {
    position: "absolute",
    inset: 0,
    display: "flex",
    width: "100%",
    minHeight: 0,
    transition: theme.transitions.create(
      ["opacity", "transform", "visibility"],
      {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeInOut,
      },
    ),
    willChange: "opacity, transform",
  },

  paperRecurringAlerts: {
    width: "100%",
    height: "400px",
    borderRadius: "10px",
    position: "relative",
  },
  gridTitle: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    textAlign: "left",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  textFieldSearch: {
    width: "100%",
    maxWidth: 400,
    display: "flex",
    flexGrow: 1,
    fontSize: "0.90rem", // diminui fonte geral
  },
  launchContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    height: "100%",
  },
  launchIcon: { cursor: "pointer", height: "19px", width: "19px" },
  containerDataGrid: { display: "flex", height: "345px" },
  containerHeaderRecurringAlerts: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    p: "10px 20px",
    "@media (max-width: 560px)": {
      flexDirection: "column",
      gap: 1,
      alignItems: "flex-start",
    },
  },
  boxRecurringAlertsSearchePrintFields: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
  },
  recurringAlertSearchField: {
    maxWidth: "242px",
  },
  recurringAlertPrintIcon: {
    color: theme.palette.primary.main,
  },
  boxTab: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  tabs: {
    mt: 1,

    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& button": {
      textTransform: "none",
    },
    minHeight: 0,
    width: "100%",
    "& .MuiTabs-flexContainer": {
      alignItems: "flex-end",
    },
    "& .MuiTab-root": {
      minHeight: 25,
      height: 25,
      padding: "14px 14px",
      fontSize: "0.85rem",
      lineHeight: 1,
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
      border: `1px solid ${theme.palette.divider}`,
      ml: theme.palette.mode === "dark" ? "" : "-1px",
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.background.paper
          : alpha(theme.palette.black.main, 0.12),

      transition: "background-color 0.15s ease, color 0.15s ease",
      "&:hover": {},
      "&.Mui-selected": {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        backgroundImage:
          theme.palette.mode === "dark"
            ? `linear-gradient(
							${alpha(theme.palette.primary.main, 0.12)},
							${alpha(theme.palette.primary.main, 0.12)}
						)`
            : "none",
      },
    },
  },
  containerChips: {
    display: "flex",
    flexDirection: "row",
    gap: 4,
    flexWrap: "nowrap",
    "@media (max-width: 500px)": {
      gap: 1,
    },
  },
  customTooltip: {
    width: "14px",
    height: "14px",
    borderRadius: "2px",
  },
  boxTooltip: {
    bgcolor: theme.palette.paletteCharts.lineCharts,
    padding: "8px",
    borderRadius: "8px",
  },
  stylesChips: {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    color:
      theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    fontWeight: "bold",
    height: "16px",
    minWidth: "16px",
    width: "auto",
    padding: "0 6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "&.MuiChip-root": {
      borderRadius: 1,
    },

    "& .MuiChip-label": {
      padding: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      lineHeight: 1,
      fontSize: "0.80rem",
    },
  },

  chipPendente: chipStatus(
    theme.palette.chip.background.high,
    theme.palette.chip.colorText.high,
  ),
  chipResolvido: chipStatus(
    theme.palette.chip.background.success,
    theme.palette.chip.colorText.success,
  ),
  chipAndamento: chipStatus(
    theme.palette.chip.background.medium,
    theme.palette.chip.colorText.medium,
  ),
  chipNovo: chipStatus(
    theme.palette.chip.background.medium,
    theme.palette.colors.purple.medium,
  ),
  chipDefault: chipStatus(
    theme.palette.chip.background.medium,
    theme.palette.colors.gray.darker,
  ),
  boxModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "1000px",
    height: "700px",
    maxHeight: "90vh",
    overflowY: "auto",
    boxShadow: 24,
    bgcolor: "background.paper",
  },
  boxCicularProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
});

export default styles;
